const EMPTY_LANGUAGES = [];

export const LEGAL_APPS = {
  wordbooks: {
    names: {
      zh: "生词本",
      en: "English Vocabulary Notebook",
    },
    policies: {
      privacy: ["zh", "en"],
    },
  },
};

export const LEGAL_LANGUAGE_LABELS = {
  zh: "中文",
  en: "English",
  ja: "日本語",
};

export function getLegalApp(slug) {
  return LEGAL_APPS[slug] || null;
}

export function getLegalAppName(app, language) {
  if (!app) return "";

  return app.names[language] || app.names.en || Object.values(app.names)[0] || "";
}

export function getPolicyLanguages(app, policyType) {
  return app?.policies?.[policyType] || EMPTY_LANGUAGES;
}
